import React from 'react';
import { RiFileCopyLine } from 'react-icons/ri';
import { EditableSection } from './informationCard';
import { userHasAccess } from '../../../supplementary_components/userDataDelegate';
import styles from './overViewCard.module.scss';
import infoCardStyles from './informationCard.module.scss';

export const OverviewCard = ({ object, setData }) => {
  return (
    <div className={`${styles.overviewCard} ${object.popup ? styles.compact : ''}`}>
      {object.overviewSection.map((section, index) => {
        if (section === null) return null;
        return (
          <GenerateEditableSection
            key={section.title + index}
            section={section}
            setData={setData}
            smallerFont={object.popup}
            wrapInBox={section.noWrap ? false : true}
          />
        );
      })}
    </div>
  );
};

export const GenerateEditableSection = ({ section, setData, smallerFont, wrapInBox = false }) => {
  const headerClass =
    section.editButton || section.copyButton || section.headerAction || section.headerLine
      ? infoCardStyles.sectionHeader
      : infoCardStyles.componentTitle;

  const content = (
    <EditableSection $smallerfont={smallerFont}>
      <div className={headerClass}>
        <span className={infoCardStyles.sectionTitleText}>{section.title}</span>
        {(section.editButton && userHasAccess(section.editAccessLevel)) || section.copyButton || section.headerAction ? (
          <div className={infoCardStyles.sectionActions}>
            {section.copyButton ? (
              <RiFileCopyLine className={infoCardStyles.copyButton} onClick={section.copyButton} />
            ) : null}
            {section.headerAction || null}
            {section.editButton && userHasAccess(section.editAccessLevel) ? (
              <button onClick={(e) => section.editButton.action(setData, e)}>
                {section.editButton.text}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
      {section.content ? (
        section.content(setData)
      ) : (
        <div className={styles.tempComponentBody}>COMING SOON</div>
      )}
    </EditableSection>
  );

  return wrapInBox ? (
    <div className={styles.sectionBox}>{content}</div>
  ) : (
    content
  );
};